import { createResponseSchema } from '@mint-sdk/api-core';
import { z } from 'zod';

export enum PlanFileTypeEnum {
  Banner = 'Banner',
  Video = 'Video',
  Audio = 'Audio',
  Presentation = 'Presentation',
  Archive = 'Archive',
}

export const FileItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  uploadedAt: z.string(),
  type: z.enum(PlanFileTypeEnum),
  url: z.string(),
  size: z.number(),
});

export const CreateUploadUrlRequestSchema = z.object({
  fileType: z.enum(PlanFileTypeEnum),
  filesInfo: z.array(
    z.object({
      fileName: z.string(),
      contentType: z.string(),
      fileSize: z.number(),
    }),
  ),
});

export const CreateUploadUrlResponseSchema = createResponseSchema(
  z.object({
    files: z.array(
      z.object({
        fields: z.record(z.string(), z.string()),
        fileId: z.string(),
        fileName: z.string(),
        storageFilePath: z.string(),
        uploadUrl: z.string(),
      }),
    ),
    errors: z.array(
      z.object({
        fileName: z.string(),
        error: z.string(),
      }),
    ),
  }),
);

export const FileListResponseSchema = createResponseSchema(FileItemSchema);
